(function () {
  // Detecta automáticamente el formato del número sin importar
  // si usa coma o punto como separador decimal (soluciona el
  // mismatch entre el formato nativo de la tienda y el que
  // inyecta WSAIO para precios ADI)
  function parseMoneyToNumber(text) {
    if (!text) return 0;
    var cleaned = text.replace(/[^0-9.,]/g, '').trim();
    if (!cleaned) return 0;

    var lastComma = cleaned.lastIndexOf(',');
    var lastDot = cleaned.lastIndexOf('.');
    var decimalSepIndex = Math.max(lastComma, lastDot);

    if (decimalSepIndex === -1) {
      return parseFloat(cleaned) || 0;
    }

    var integerPart = cleaned.substring(0, decimalSepIndex).replace(/[.,]/g, '');
    var decimalPart = cleaned.substring(decimalSepIndex + 1).replace(/[^0-9]/g, '');

    var value = parseFloat(integerPart + '.' + decimalPart);
    return isNaN(value) ? 0 : value;
  }

  function formatCRC(value) {
    var fixed = value.toFixed(2);
    var parts = fixed.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '₡' + intPart + ',' + parts[1];
  }

  function getCartValueFromDOM() {
    // Solo <span class="price--end">, excluye el <s> (precio tachado)
    var priceEls = document.querySelectorAll(
      '.wt-cart__item__price-wrapper span.price--end'
    );
    var total = 0;
    priceEls.forEach(function (el) {
      total += parseMoneyToNumber(el.textContent);
    });
    return total;
  }

  function recalcBar(barEl) {
    var isAdi = barEl.getAttribute('data-is-adi') === 'true';
    if (!isAdi) return;

    var threshold = parseFloat(barEl.getAttribute('data-threshold')) || 45999;
    var textTemplate = barEl.getAttribute('data-text-template') || '';
    var successText = barEl.getAttribute('data-success-text') || '';

    var itemEls = document.querySelectorAll('.wt-cart__item__price-wrapper span.price--end');
    if (itemEls.length === 0) return;

    var cartValue = getCartValueFromDOM();
    var remaining = threshold - cartValue;
    var progress = Math.round((cartValue * 100) / threshold);

    if (remaining < 0) {
      remaining = 0;
      progress = 100;
    }

    var textEl = barEl.querySelector('.wt-free-shipping-bar__text');
    var fillEl = barEl.querySelector('.wt-progress-bar__fill');

    if (textEl) {
      if (remaining > 0) {
        textEl.textContent = textTemplate.replace('||amount||', formatCRC(remaining));
      } else {
        textEl.textContent = successText;
      }
    }
    if (fillEl) {
      fillEl.style.width = progress + '%';
    }
  }

  function recalcAllBars() {
    document.querySelectorAll('.wt-free-shipping-bar').forEach(recalcBar);
  }

  var observer = new MutationObserver(function () {
    clearTimeout(window.__adiFreeShippingDebounce);
    window.__adiFreeShippingDebounce = setTimeout(recalcAllBars, 150);
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  document.addEventListener('cart:updated', recalcAllBars);
  document.addEventListener('cart:refresh', recalcAllBars);

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(recalcAllBars, 400);
  });
  setTimeout(recalcAllBars, 800);
})();